import { Card } from "antd";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Locale } from "../../utils";
import { addBlock } from "../../utils/redux/actions/CustomPage";
import { getBlocks } from "../../utils/redux/reducers/CustomPage";
import {
  BLOCK_TYPES,
  getDefaultBlockConfig,
  getBlockTypeLabel,
  validateBlockLimits,
} from "./blockConfigs";
import { message } from "antd";
import "./BlockPalette.scss";

const i18n = Locale.getInstance();

const BlockPalette = () => {
  const dispatch = useDispatch();
  const blocks = useSelector(getBlocks);

  const handleAddBlock = (blockType) => {
    const validation = validateBlockLimits(blocks, blockType);
    if (!validation.valid) {
      message.warning(i18n.t(validation.message));
      return;
    }

    const newBlock = getDefaultBlockConfig(blockType);
    newBlock.order = blocks.length;
    dispatch(addBlock(newBlock));
  };

  const blockTypes = [
    BLOCK_TYPES.BANNER,
    BLOCK_TYPES.PRODUCT_GRID,
    BLOCK_TYPES.CATEGORY_GRID,
    BLOCK_TYPES.NAVIGATION,
    BLOCK_TYPES.VIDEO,
    BLOCK_TYPES.ADVERTISEMENT,
    BLOCK_TYPES.TEXT,
    BLOCK_TYPES.FLASH_SALE,
  ];

  return (
    <div className="block-palette">
      <h3>{i18n.t("customPage.blockPalette")}</h3>
      <div className="block-types">
        {blockTypes.map((type) => (
          <Card
            key={type}
            hoverable
            className="block-type-card"
            onClick={() => handleAddBlock(type)}
          >
            {getBlockTypeLabel(type, i18n)}
          </Card>
        ))}
      </div>
    </div>
  );
};

export default BlockPalette;

